export const globalTracker = {
  actions: {
    buttonQuotationKey: 'Cotar equipamentos',
    buttonProposalKey: 'Criar nova proposta',
  },
}
